import React, { useEffect } from 'react';
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import Radio from 'relements/build/esm/input/radio';
import Avatar from 'relements/build/esm/ui/avatar';
import { Container as Card } from '@src/components/ToolCard/styledComponents';
import { getBrands } from './actions';
import { LOGO_BASE_URL } from './const';
import LoadingState from './LoadingState';

const commonProps = {
  padding: 'zero',
  marginY: 'lg',
  flexWrap: 'wrap',
};

const Brands = ({ setSelection, selectedPortal, selectedBrand }) => {
  const [loading, setLoading] = React.useState(false);
  const [brands, setBrands] = React.useState([]);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const {
        response: { body },
      } = await getBrands(selectedPortal);
      const updatedBrands = body.data
        .filter((brand) => brand.enabled)
        .map((brand) => ({
          title: brand.name,
          id: brand.id,
          logoUrl: brand.logo_url,
        }));
      setBrands(updatedBrands);
      if (
        updatedBrands.filter((brand) => brand.id === selectedBrand).length === 0
      ) {
        setSelection('brands', '');
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  const updateSelection = (brandId) => {
    if (brandId) setSelection('brands', brandId);
  };

  return (
    <>
      <Text variants="body.md" color="haptik.black">
        Select a brand to be associated with bot
      </Text>
      {loading ? (
        <LoadingState />
      ) : (
        <Box {...commonProps}>
          <Radio.Themed
            onChange={updateSelection}
            selectedValue={selectedBrand}
            mode="stacked"
          >
            {brands.map((brand) => (
              <Radio.Themed.Item value={brand.id} key={brand.id}>
                <Box width="300px">
                  <Card>
                    <Box alignItems="center" padding={0}>
                      <Avatar
                        url={LOGO_BASE_URL + brand.logoUrl}
                        initials={brand.title.substring(0, 2)}
                        marginRight="md"
                      />
                      <Text>{brand.title}</Text>
                    </Box>
                  </Card>
                </Box>
              </Radio.Themed.Item>
            ))}
          </Radio.Themed>
        </Box>
      )}
    </>
  );
};

export default Brands;
